var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('span',{staticClass:"btn",attrs:{"role":"button"}},[_c('FontawesomeIcon',{staticClass:"icn",attrs:{"icon":['fal','pencil-alt']}}),_vm._v(" 編集 ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }